import { createFileRoute } from '@tanstack/react-router';
import { AccountsPageContent } from '~/app/index';
import { contentFor } from '~/content/localized';
import { pageHeadMeta } from '~/lib/seo';
import heroCss from '~/styles/hero.css?inline';

/**
 * Arabic homepage.
 *
 * A static `/ar` route rather than a segment on the existing `$locale` catch-all:
 * `$locale` only serves the 31 whitelisted Webflow paths and renders English
 * components, so reusing it would have meant special-casing Arabic inside a module
 * whose whole job is regional English. A static route also wins over `$locale`
 * in TanStack's ranking, so `/ar` can never fall through to that 404.
 *
 * `AccountsPageContent` is shared with the English route unchanged — the language
 * comes from the URL via `useLanguage()`, so the page picks its own copy.
 */
export const Route = createFileRoute('/ar/')({
  head: () =>
    pageHeadMeta({
      title: 'حساب عالمي بالدولار واليورو والإسترليني — nsave',
      description:
        'افتح حساب nsave واستقبل فلوسك بالدولار واليورو والإسترليني، وحوّل لبلدك بأفضل سعر متاح، واستثمر من دولار واحد.',
      path: '/ar',
      inlineStyles: [heroCss],
    }),
  component: ArabicHomePage,
});

function ArabicHomePage() {
  // The English loader fetches the FAQ from Payload, which has no Arabic content.
  // `AccountsPageBody` substitutes the Arabic FAQ from the content bundle, so this
  // value is only a shape-satisfying fallback and is never rendered here.
  return <AccountsPageContent faqContent={contentFor('ar').shared.defaultFaq} />;
}
